import React from 'react';
import { Badge, BadgeProps } from '@economic/gaudi';
import { t } from '../../shared/components/l10n/l10n';

type NavigationBadgeProps = Omit<BadgeProps, 'children'> & {
    children?: React.ReactNode;
};

export function NavigationBadge({
    children = t`HEADER_TAB_NEW_BADGE`,
    state = 'information',
    style,
    ...props
}: NavigationBadgeProps) {
    return (
        <Badge
            {...props}
            style={{
                position: 'absolute',
                top: '-6px',
                right: '-5px',
                fontSize: '0.4rem',
                height: '0.75rem',
                padding: '0 0.3rem',
                ...style,
            }}
            state={state}>
            {children}
        </Badge>
    );
}
